import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listDistributor } from '@/api/deposit.js';
import YTable from '@/views/components/table/index.vue';
import AddDepositComponent from './components/deposit/add.vue';
import ReduceDepositComponent from './components/deposit/reduce.vue';
import DetailComponent from './components/deposit/detail.vue';
import dayjs from 'dayjs';
import { listCashPledgeStatus } from '@/api/dict.js';
export default {
  name: 'deposit-index',
  components: {
    YTable: YTable,
    AddDepositComponent: AddDepositComponent,
    ReduceDepositComponent: ReduceDepositComponent,
    DetailComponent: DetailComponent
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    return {
      searchForm: {
        page: 1,
        pageSize: 10,
        total: 0,
        isCashPledgeRecords: 1
      },
      initialized: false,
      dataLoading: false,
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      statusList: listCashPledgeStatus(),
      dataList: [],
      columns: [{
        label: '经销商名称',
        prop: 'name',
        checked: true,
        width: 200
      }, {
        label: '押金总额',
        prop: 'cashPledgeTotal',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return val.toFixed(2);
        }
      }, {
        label: '产品押金',
        prop: 'dealerProductPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return val.toFixed(2);
        }
      }, {
        label: '工具押金',
        prop: 'dealerToolPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return val.toFixed(2);
        }
      }, {
        label: '押金审核',
        prop: 'pendingExamine',
        checked: true,
        width: 100,
        slot: 'pendingExamine'
      }, {
        label: '寄售产品总金额',
        prop: 'cashPledgeTotalMoney',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '押金比例',
        prop: 'dealerCashPledgeRatio',
        checked: true,
        width: 150,
        formatter: function formatter(val) {
          return (Number(val) * 100).toFixed(2) + '%';
        }
      }, {
        label: '押金比例红线',
        prop: 'dealerCashPledgeRatioConf',
        checked: true,
        width: 150,
        formatter: function formatter(val) {
          return Number(val).toFixed(2) + '%';
        }
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 200,
        fixedWidth: true,
        fixed: 'right',
        slot: 'operations'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;

                if (that.initialized) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return that.loadData();

              case 4:
                that.initialized = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.dataList = [];
                that.dataLoading = true;
                _context2.prev = 3;
                _context2.next = 6;
                return listDistributor(that.searchForm).then(function (res) {
                  res.list.map(function (row) {
                    row.cashPledgeTotal = row.dealerProductPrice + row.dealerToolPrice;
                    row.pendingExamine = {
                      amount: 0,
                      num: 0,
                      type: ''
                    };

                    if (row.manufacturerCashPledgeRecords.length > 0) {
                      row.pendingExamine.num = row.manufacturerCashPledgeRecords.length;
                      row.pendingExamine.amount = row.manufacturerCashPledgeRecords[0].productPrice || row.manufacturerCashPledgeRecords[0].toolPrice;
                    }

                    if (row.pendingExamine.amount > 0) {
                      row.pendingExamine.amount = '+' + row.pendingExamine.amount.toFixed(2);
                      row.pendingExamine.type = '';
                    } else if (row.pendingExamine.amount < 0) {
                      row.pendingExamine.amount = row.pendingExamine.amount.toFixed(2);
                      row.pendingExamine.type = 'danger';
                    } else {
                      row.pendingExamine.amount = '0';
                    }
                  });
                  that.dataList = res.list;
                  that.searchForm.total = res.total;
                }).catch(function (e) {});

              case 6:
                _context2.next = 10;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);

              case 10:
                that.dataLoading = false;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 8]]);
      }))();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    addDeposit: function addDeposit(row) {
      var that = this;
      var appRow = {
        manuId: row.ID,
        manuName: row.name,
        productPrice: 0,
        toolPrice: 0,
        payType: null,
        optionType: 1,
        // 1=增加 2=减少
        receiptTime: dayjs().format('YYYY-MM-DD'),
        mark: null,
        pictureLicense: [],
        // 凭证
        collectionCompanyId: null,
        // 付款公司ID
        collectionCompanyName: null,
        // 付款公司名称
        collectionCompanyBank: null,
        // 银行名称
        collectionCompanyBankAccount: null,
        // 银行账号
        handledByUid: null,
        handledByUname: null,
        status: 2,
        source: 2,
        subsidiarys: row.subsidiarys
      };
      that.$refs.AddDepositComponentRef.init(appRow, 'EDIT');
    },
    reduceDeposit: function reduceDeposit(row) {
      var that = this;
      var appRow = {
        id: null,
        dealerProductPrice: row.dealerProductPrice,
        dealerToolPrice: row.dealerToolPrice,
        manuId: row.ID,
        manuName: row.name,
        productPrice: 0,
        toolPrice: 0,
        payType: null,
        optionType: 2,
        // 1=增加 2=减少
        receiptTime: dayjs().format('YYYY-MM-DD'),
        mark: null,
        pictureLicense: [],
        // 凭证
        collectionCompanyId: row.ID,
        // 付款公司ID
        collectionCompanyName: row.name,
        // 付款公司名称
        collectionCompanyBank: row.bank,
        // 银行名称
        collectionCompanyBankAccount: row.bank_account,
        // 银行账号
        handledByUid: null,
        handledByUname: null,
        status: 2,
        source: 2,
        subsidiarys: row.subsidiarys
      };
      that.$refs.ReduceDepositComponentRef.init(appRow, 'EDIT');
    },
    showDetail: function showDetail(row) {
      var that = this;
      var appRow = JSON.parse(JSON.stringify(row));
      that.$refs.DetailComponentRef.init(appRow, 2);
    },
    viewApply: function viewApply(manuRow, row) {
      var that = this;
      var appRow = JSON.parse(JSON.stringify(row));
      appRow.dealerProductPrice = manuRow.dealerProductPrice;
      appRow.dealerToolPrice = manuRow.dealerToolPrice;
      appRow.pictureLicense = appRow.pictureLicense ? JSON.parse(appRow.pictureLicense) : [];

      if (appRow.optionType === 1) {
        that.$refs.AddDepositComponentRef.init(appRow);
      } else if (appRow.optionType === 2) {
        that.$refs.ReduceDepositComponentRef.init(appRow);
      }
    },
    statusFormatter: function statusFormatter(status) {
      var that = this;
      var findRow = that.statusList.find(function (item) {
        return item.ID === status;
      });

      if (findRow) {
        return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
      } else {
        return status;
      }
    }
  }
};